<template>
	<div class="yongDetail">
		<!-- 导航栏 -->
		<back-to :title="productList.title"></back-to>
		<!-- 轮播 -->
		<section class="detailSwiper">
			<van-swipe class="detailSwiper-swiper-bg" :loop="false" indicator-color="white">
				<van-swipe-item v-for="(item, index) in productList.pictureList" :key="index">
					<img v-lazy="item.url" v-if="!item.isMp4" />
					<video v-else ref="myVideo" :src="item.url" :controls="true" oncontextmenu="return false"
						muted="muted" autoplay="autoplay" loop="-1" controlslist="nodownload" class="video-box"></video>
				</van-swipe-item>
			</van-swipe>
		</section>
		<section class="yongDetailContent">
			<div class="content-common">
				<h2 class="content-price-top">{{productList.title}}</h2>
				<span class="content-price-center">
					<section v-if="!productList.isFree">
						<label class="price" v-if="productList.price > 0">
							<font>￥</font>{{productList.price}}
							<p>起</p>
						</label>
						<label class="price" v-if="productList.price == 0">敬请期待</label>
					</section>
					<section v-else>
						<label class="price">免费</label>
					</section>
				</span>
				<span class="content-price-bottom">
					<label for="">编号：{{productList.productType}}{{productList.id}}</label>
				</span>
			</div>
			<!-- 描述 -->
			<div class="content-common content-desc">
				<label for="" v-for="(item,index) in recommed" :key="index">
					<img src="../../assets/wyq-blue-star.png" />
					<p>{{item}}</p>
				</label>
			</div>
			<!-- 属性购买列表 -->
			<div class="content-common content-buy" v-if="!productList.isFree">
				<span class="content-buy-list" v-for="(item,index) in productList.tickets" :key="index">
					<label class="buy-list_title" for="">{{item.skuName?item.skuName:item.name}}</label>
					<label class="buy-list_price" for="">
						<label>{{ item.mpContent }}</label>
						<label v-if="item.price > 0">
							<font>￥</font>{{ item.price }}
						</label>
					</label>
					<label class="buy-list_pay" for="">
						<p v-if="item.price > 0" class="nav"
							@click="$router.push({ path: '/choice',query:{id:productList.id,proTypeID:item.skuid,skuIndex:index,orderType:8}})">
							购买</p>
						<p v-if="item.price == 0" class="nav-1">敬请期待</p>
					</label>
				</span>
			</div>
			<!-- 景点介绍v-if="productList.msg.length > 0" -->
			<div class="content-common content-pro" v-if="productListContent != ''">
				<h2 class="content-pro-title">{{productListContent.title}}</h2>
				<div class="spot-part" v-html="productListContent.content"></div>
			</div>
			<!-- 其他介绍 -->
			<div class="content-common content-pro" v-for="(item,index) in productList.details" :key="index">
				<h2 class="content-pro-title">{{item.title}}</h2>
				<div class="spot-part" v-html="item.content"></div>
			</div>
			<!-- 推荐商品 -->
			<div class="content-common content-list">
				<h2 class="content-pro-title">推荐商品</h2>
				<div class="content-list_item" v-for="(item,index) in goodsList" :key="index"
					@click="id=item.id,getData(),scrollTo()">
					<span>
						<img v-lazy="item.imageUrl" />
					</span>
					<span class="goods-text">
						<label for="" class="goods-title">{{item.title}}</label>
						<label for="" class="goods-desc">{{item.desc}}</label>
						<label for=""
							class="goods-price">{{!item.isFree && item.price > 0?'￥'+ item.price:'免费'}}</label>
					</span>
				</div>
			</div>
		</section>
		<!-- 购买按钮 -->
		<section class="detailBottom">
			<a href="tel:02425836666">咨询</a>
			<span class="" v-if="productList.price > 0 && productList.tickets.length > 0"
				@click="$router.push({ path: '/choice',query:{id:$route.query.id,proTypeID:productList.tickets[0].skuid,orderType:8}})">选择购买</span>
			<span v-else class="grays">选择购买</span>
		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	export default {
		name: 'yongDetail',
		components: {
			BackTo
		},
		data() {
			return {
				goodsList: [],
				productList: [],
				recommed: [],
				id: 1,
				productListContent: ""
			}
		},
		created() {
			this.id = this.$route.query.id
		},
		mounted() {
			this.getData()
		},
		methods: {
			scrollTo() {
				window.scrollTo(0, 0)
			},
			getGoodsList() {
				var jsonData = {
					tagName: '周边游',
					merchantId: 0,
					pageIndex: 1,
					isZeroShow: false,
					organizationId: 60,
					xqsnType: 20
				}

				this.$post(
					this.$apiList + '/NewNearTravel/GetNearTravel_List', jsonData
				).then(res => {
					this.goodsList = res.result.tag.tagProductList
				})
			},
			getData() {
				this.$post(
					this.$apiList + '/NewNearTravel/GetNearTravelProductByID?id=' + this.id +
					'&MerchantId=0&OrganizationId=60', {}
				).then(res => {
					// 轮播开始
					let ob = null
					let obindex
					res.result.productList[0].pictureList.forEach((e, index) => {
						if (e.url.indexOf('mp4') != -1) {
							e.isMp4 = true
							ob = JSON.stringify(e)
							obindex = index
						} else {
							e.isMp4 = false
						}
					});
					if (ob != null) {
						res.result.productList[0].pictureList.splice(obindex, 1)
						res.result.productList[0].pictureList.unshift(JSON.parse(ob))

					}
					// 轮播结束

					res.result.productList[0].details = this.setImg(res.result.productList[0].details)
					this.productList = res.result.productList[0]
					this.recommed = res.result.productList[0].highlights.split(";")
					if (res.result.productList[0].msg.length > 0) {
						this.productListContent = this.setImg(res.result.productList[0].msg)[0]
					} else {
						this.productListContent = ""
					}
					this.getGoodsList()
				})
			},
			// 设置图片class
			setImg(data) {
				let img = data
				data.forEach((element, i) => {
					img[i].content = img[i].content.replace(/<p([\s\w"=\/\.:;]+)((?:(style="[^"]+")))/ig, '<p')
						.replace(/<p>/ig, '<p style="font-size: 15px; line-height: 25px;">')
						.replace(/<img([\s\w"-=\/\.:;]+)((?:(height="[^"]+")))/ig, '<img$1')
						.replace(/<img([\s\w"-=\/\.:;]+)((?:(width="[^"]+")))/ig, '<img$1')
						.replace(/<img([\s\w"-=\/\.:;]+)((?:(style="[^"]+")))/ig, '<img$1')
						.replace(/<img([\s\w"-=\/\.:;]+)((?:(alt="[^"]+")))/ig, '<img$1')
						.replace(/<img([\s\w"-=\/\.:;]+)/ig, '<img style="width: 100%;" $1');
				});
				return img
			}

		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
		}
	}
</script>

<style>
	.yongDetail .detailSwiper,
	.yongDetail .detailSwiper-swiper-bg {
		width: 100%;
		height: 500px;
		z-index: -1
	}

	.yongDetail .detailSwiper-swiper-bg img,
	.yongDetail .detailSwiper-swiper-bg video {
		width: 100%;
		height: 100%;
		object-fit: fill;
	}

	.yongDetail .van-swipe__indicators {
		margin-bottom: 20px
	}

	.yongDetailContent {
		width: 100%;
		padding: 0 28px;
		box-sizing: border-box;
		margin-top: -25px;
		z-index: 66;
		padding-bottom: 120px;
	}

	.content-common {
		width: 100%;
		background-color: #fff;
		border-radius: 24px;
		padding: 30px 20px;
		box-sizing: border-box;
		margin-bottom: 20px;
	}

	.content-price-top {
		font-size: 36px;
	}

	.content-price-center {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 40px 0 30px 0;
		border-bottom: 1px solid #eee;
	}

	.price {
		font-size: 42px;
		font-weight: bold;
		color: #ff6d00;
		display: flex;
		align-items: baseline;
	}

	.price font {
		font-size: 22px;
		padding-right: 7px;
	}

	.price p {
		font-size: 22px;
		color: #999;
		font-weight: 400;
		padding-left: 7px;
	}

	.content-price-bottom {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 30px;
		color: #999;
		font-size: 26px;
	}

	.content-desc {
		display: flex;
		flex-direction: column;
		width: 100%;
		font-size: 26px;
		line-height: 38px;
		color: #333;
	}

	.content-desc p {
		width: 614px;
	}

	.content-desc label {
		display: flex;
		align-items: baseline;
		margin-bottom: 20px;
	}

	.content-desc img {
		margin-top: 6px;
		margin-right: 20px;
		width: 20px;
		height: 20px;
	}

	.content-buy-list {
		background-color: #fff6f3;
		margin-bottom: 20px;
		padding: 24px;
		box-sizing: border-box;
		border-radius: 10px;
		display: block;
	}

	.content-buy-list:last-child {
		margin-bottom: 0;
	}

	.buy-list_title {
		font-size: 30px;
		font-weight: bold;
		line-height: 1.2;
	}

	.buy-list_price {
		display: flex;
		justify-content: space-between;
		color: #a6a6a6;
		font-size: 24px;
		padding: 20px 0;
	}

	.buy-list_price label:last-child {
		color: #ff6d00;
		font-size: 30px;
		font-weight: bold;
	}

	.buy-list_price label:last-child font {
		font-size: 20px;
		font-weight: normal;
	}

	.buy-list_pay {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.nav {
		width: 130px;
		height: 44px;
		font-size: 24px;
		text-align: center;
		border-radius: 22px;
		color: #fff;
		line-height: 44px;
		background: rgba(255, 109, 0, 1);
	}

	.nav-1 {
		width: 130px;
		height: 44px;
		font-size: 24px;
		text-align: center;
		border-radius: 22px;
		color: #999;
		line-height: 44px;
		background: #eee
	}

	.content-pro-title {
		margin-bottom: 40px;
		box-sizing: border-box;
		font-size: 36px;
		font-weight: bold;
	}

	.spot-part {
		width: 100%;
		box-sizing: border-box;
		font-size: 26px;
		line-height: 40px;
	}

	.content-list_item {
		display: flex;
		align-items: center;
		padding: 30px 0;
		border-bottom: 1px solid #f4f4f4;
		box-sizing: border-box;
	}

	.content-list_item:last-child {
		border-bottom: 0;
		padding-bottom: 0;
	}

	.content-list_item img {
		margin-right: 20px;
		width: 200px;
		height: 200px;
		border-radius: 10px;
	}

	.goods-text {
		height: 200px;
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.goods-title {
		font-size: 28px;
		font-weight: bold;
		color: #333;
		margin-bottom: 10px;
	}

	.goods-desc {
		font-size: 22px;
		color: #555555;
		/* line-height: 1.2; */
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.goods-price {
		font-size: 30px;
		color: #F9902F;
		margin-top: auto;
		margin-left: auto;
	}
</style>
